module.exports = ".default-font {\r\n    font-family: lato;\r\n    letter-spacing: 0;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/app_element/layout_app_element/layout-app-element.component.css
// module id = ./src/app/app_manager/app_element/layout_app_element/layout-app-element.component.css
// module chunks = main